<script>
export default {
    props: ['name', 'data', 'config']
};
</script>



// WEBPACK FOOTER //
// SectionFieldtype.vue?e202d6a2